import React from 'react'
import { css } from 'react-emotion'
import { ExternalButtonLink } from 'stylist'

const BookFVButton = () => (
  <ExternalButtonLink
    kind="primary"
    className={css`
      && {
        margin-left: 1rem;
      }
    `}
    href="https://book.focusvision.com"
  >
    Book Project
  </ExternalButtonLink>
)

export default BookFVButton



// WEBPACK FOOTER //
// ./src/routes/components/BookFVButton.js